import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { servicesData } from '../../../mocks/services';

const ServicesSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="inline-block bg-primary/10 text-primary px-4 py-2 rounded-full text-sm font-semibold mb-4">
            NOS SERVICES
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-primary mb-4">
            Une Gamme Complète de
            <br />
            Solutions Logistiques
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            De la logistique internationale au transport aérien et maritime vers l'Afrique, nous offrons des services adaptés à tous vos besoins d'expédition et de stockage.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service, index) => (
            <motion.div
              key={service.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className="group bg-white border border-gray-200 rounded-2xl p-8 hover:shadow-xl hover:border-accent/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-accent/10 rounded-xl mb-6 group-hover:bg-accent group-hover:scale-110 transition-all duration-300">
                <i className={`${service.icon} text-3xl text-accent group-hover:text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-primary mb-3 group-hover:text-accent transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                {service.description}
              </p>
              <Link
                to={service.link}
                className="inline-flex items-center text-accent font-semibold text-sm group-hover:gap-2 transition-all cursor-pointer"
              >
                En savoir plus
                <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.6, duration: 0.6 }}
          className="text-center mt-12"
        >
          <Link
            to="/services"
            className="inline-flex items-center bg-primary hover:bg-primary-light text-white px-8 py-4 rounded-full font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Découvrir Tous Nos Services
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
